<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 8H8.00667" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.6668 4.0026V2.66927C10.6668 2.31565 10.5264 1.97651 10.2763 1.72646C10.0263 1.47641 9.68712 1.33594 9.3335 1.33594H6.66683C6.31321 1.33594 5.97407 1.47641 5.72402 1.72646C5.47397 1.97651 5.3335 2.31565 5.3335 2.66927V4.0026" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.6668 8.66406C12.6887 9.97005 10.3705 10.6663 8.00016 10.6663C5.6298 10.6663 3.31163 9.97005 1.3335 8.66406" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.3333 4H2.66659C1.93021 4 1.33325 4.59695 1.33325 5.33333V12C1.33325 12.7364 1.93021 13.3333 2.66659 13.3333H13.3333C14.0696 13.3333 14.6666 12.7364 14.6666 12V5.33333C14.6666 4.59695 14.0696 4 13.3333 4Z" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#C9408C',
    },
  },
};
</script>
